exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".special-travels .dark-overlay {\n  background: #ff404e;\n  height: 80px; }\n\n.special-travels .card {\n  margin-top: 20px; }\n  .special-travels .card img {\n    max-height: 200px; }\n  .special-travels .card:hover {\n    -webkit-transform: scale(1.025453);\n            transform: scale(1.025453);\n    transition: all 200ms linear; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/special-travels/special-travels.component.scss
// module id = ../../../../../src/app/pages/special-travels/special-travels.component.scss
// module chunks = main